<template>
  <div class="body">
    <div class="body-container">
      <div class="college-container" v-for="(item, index) in collegeList" :key="index" @click="gotoCollege(item)">
        <div>
          <img class="college-img" :src="item.images"/>
        </div>
        <div class="college-content">
          <div class="college-title">{{ item.name }}</div>
          <div class="college-breif">{{ item.intro }}</div>
        </div>
      </div>
      <div class="pagination">
        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pageSize"
          @pagination="loadCollegeList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getCollegeList } from "@/api/famous"

export default {
  name: "Famous",
  data() {
    return {
      collegeList: [],
      total: 0,
      queryParams: {
        page: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.initPageData();
  },
  methods: {
    initPageData() {
      this.loadCollegeList();
    },

    loadCollegeList() {
      getCollegeList(this.queryParams).then(res => {
        this.collegeList = res.data.list;
        this.total = res.data.pageData.totalCount;
      });
    },

    gotoCollege(college) {
      window.open(college.url);
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @use "famous.scss";
</style>
